<script>
    /*
        文字可以复制：https://segmentfault.com/a/1190000016963084
        链接点击跳转：https://blog.csdn.net/baidu_40523514/article/details/123809416
    */
    import { onMount } from "svelte";
    import Loading from "../loading/Loading.svelte";
    import Plus from "../icons/plus.svelte";
    import Minus from "../icons/minus.svelte";
    import * as pdfjs from "pdfjs-dist";
    import { TextLayerBuilder } from "pdfjs-dist/web/pdf_viewer";
    import "pdfjs-dist/web/pdf_viewer.css";
    let cls = "sui-pdfviewer";
    let canvasBox;
    let pdfObj;
    let currentPage = 1;
    let pageNumbers = 0;
    let step = 3;
    let lock = false;
    let anchor;
    let show = true;
    let diabaled = false;
    let index = 1;
    let scale = 1;
    let pageScale = 1;
    let w = window.innerWidth;
    let y;
    let pageHeight = window.innerHeight;
    let pageSize = 1;
    $: {
        pageSize = Math.max(1, Math.round(y / pageHeight) + 1);
    }

    export let url =
        "https://t1.market.xiaomi.com/download/Finance/09a00ed8861b448b094cf5e6ab22c95e1139506d6/bxtk.pdf?origin=allow";
    export let lazyLoad = true;
    export let textCopy = false;
    export let showToolBar = true;

    //
    pdfjs.GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js";
    //
    onMount(() => {
        const loadingTask = pdfjs.getDocument(url);
        loadingTask.promise
            .then(function (pdf) {
                pdfObj = pdf;
                pageNumbers = pdf.numPages;

                setTimeout(init, 0);
            })
            .catch((error) => {
                console.log(error.message);
            });
    });

    function renderPage(page) {
        show = true;
        let canvasContainer;
        if (textCopy) {
            canvasContainer = document.createElement("div");
            canvasContainer.style.position = "relative";
        }
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        let viewport = page.getViewport({ scale: scale });
        if (viewport.width !== w) {
            scale = w / viewport.width;
            viewport = page.getViewport({ scale: scale });
        }
        // Support HiDPI-screens.
        let outputScale = window.devicePixelRatio || 1;
        pageHeight = viewport.height;
        canvas.width = Math.floor(viewport.width * outputScale);
        canvas.height = Math.floor(viewport.height * outputScale);
        canvas.style.width = Math.floor(viewport.width) + "px";
        canvas.style.height = Math.floor(viewport.height) + "px";

        const transform =
            outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null;
        //
        if (textCopy) {
            canvasContainer.appendChild(canvas);
            canvasBox.appendChild(canvasContainer);
        } else {
            canvasBox.appendChild(canvas);
        }
        const renderContext = {
            canvasContext: context,
            transform: transform,
            viewport: viewport,
        };

        if (textCopy) {
            page.render(renderContext)
                .promise.then(() => {
                    return page.getTextContent();
                })
                .then((textContent) => {
                    const textLayerDiv = document.createElement("div");
                    textLayerDiv.setAttribute("class", "textLayer");
                    canvasContainer.appendChild(textLayerDiv);
                    const textLayer = new TextLayerBuilder({
                        textLayerDiv: textLayerDiv,
                        pageIndex: page.pageIndex,
                        viewport: viewport,
                    });
                    textLayer.setTextContent(textContent);
                    textLayer.render();
                });
        } else {
            page.render(renderContext);
        }
        show = false;
    }

    function init() {
        if (diabaled) return;
        diabaled = true;
        if (pageNumbers === 0 || lock) return;
        let num = lazyLoad ? step * currentPage : pageNumbers;
        if (pageNumbers < step * currentPage) {
            lock = true;
            num = pageNumbers;
        }
        let i = index;
        //
        for (; i <= num; i++) {
            pdfObj.getPage(i).then(function (page) {
                renderPage(page);
            });
            index++;
        }
        currentPage++;
        setTimeout(() => {
            diabaled = false;
        }, 1000);
    }

    function handleScroll(e) {
        if (!lazyLoad) return;
        if (anchor) {
            const iH = window.innerHeight;
            const { top } = anchor.getBoundingClientRect();
            if (top < iH + iH / 2) {
                init();
            }
        }
    }

</script>

<div class={`${cls}-wrapper`}>
    {#if showToolBar}
        <div class={`${cls}-toolbar`}>
            <div class={`${cls}-toolbar-count`}>
                {pageSize} / {pageNumbers}
            </div>
            <Minus
                size={20}
                on:click={() => (pageScale -= 0.5)}
                color="var(--sui-color-primary)"
            />
            <Plus
                size={20}
                on:click={() => (pageScale += 0.5)}
                color="var(--sui-color-primary)"
            />
        </div>
    {/if}
    <div class={`${cls}-conatiner`}>
        <div
            class={cls}
            bind:offsetWidth={w}
            bind:this={canvasBox}
            style:--scale={pageScale}
        />
    </div>
    <div class={`${cls}-anchor`} bind:this={anchor} />
</div>
<Loading inline {show} />
<svelte:window on:scroll={handleScroll} bind:scrollY={y} />

<style lang="less">
    @import './pdfviewer.less';
</style>
